import React from 'react';
import Draggable from 'react-draggable';

// Shared components and utilities
import { OmniIconComponent, OmniDropdownComponent, OmniTooltipNextComponent, Utils } from '../../../../shared';
export class CampaignFilterComponent extends React.Component {
    nodeRef = null;
    defaultState = {
        filterOptions: {
            campaignName: '',
            startDate: '',
            endDate: '',
            budgetMin: '',
            budgetMax: '',
            clientName: '',
            clientCode: '',
            productCode: '',
            estimateCode: ''
        },
        isMenuActive:false,
        exportStatusOptions : [
            {"id":"Accepted","value":"Accepted"},
            {"id":"Campaign Sent","value":"Campaign Sent"},
            {"id":"Error","value":"Error"},
            {"id":"Export Error","value":"Export Error"},
            {"id":"Needs Update","value":"Needs Update"},
            {"id":"Not Exported","value":"Not Exported"},
            {"id":"Synced","value":"Synced"},
            {"id":"Sync Error","value":"Sync Error"},
            {"id":"Updated","value":"Updated"},
        ]
    };
    constructor(props) {
        super(props);
        this.state = this.defaultState;
        this.nodeRef = React.createRef();
    }
    
    componentDidMount() {
        this.handleDropdownClick();
    }

    handleDropdownClick() {
        if (!this.loaded) {
            this.loaded = true;
            // Get all dropdowns on the page that aren't hoverable.
            this.dropdowns = document.querySelectorAll('.dropdown:not(.is-hoverable)');

            if (this.dropdowns.length > 0) {
                // For each dropdown, add event handler to open on click.
                this.dropdowns.forEach((el) => {
                    el.addEventListener('click', (e) => {
                        //first close all dropdown
                        this.closeDropdowns(e);
                        if (!el.classList.contains("is-active")) {
                            el.classList.toggle('is-active');
                            let container = document.querySelectorAll('.dropdown-content');
                            let exists = false;
                            container.forEach((item) => {
                                if ((!exists && item === e.target) || item.contains(e.target)) {
                                    exists = true
                                }
                            })

                            if (!exists) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        }
                    });
                });

                // If user clicks outside dropdown, close it.
                document.addEventListener('click', (e) => {
                    this.closeDropdowns(e);
                });
            }
        }
    }

    closeDropdowns = (e) => {
        this.dropdowns.forEach(function (el) {
            el.classList.remove('is-active');
        });
    }

    handleModalClick = (event) => {
        event.stopPropagation();
    }

    /**
    * The above code is a JavaScript function called `toggleMenu` that is used to toggle the
    * visibility of a dropdown menu. When the function is called, it prevents the default behavior of
    * the event and stops it from propagating further. It then toggles the visibility of the dropdown
    * menu by adding or removing the CSS class "show" to the element with the ID
    * "dropdown-menu-content".
    * @param {html event} event
    */
    toggleMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        document.getElementById("dropdown-menu-content").classList.toggle("show");
        const isMenuActive = document.getElementById("dropdown-menu-content")?.classList.contains("show") ? true : false;
        if(isMenuActive){
            document.querySelectorAll("om2-dropdown-impl").forEach(eachEle =>{
                eachEle.shadowRoot.querySelector(".dropdown-content").style.position = "initial";
            });
        }
        this.setState({isMenuActive})
    }

    getEventTarget(e) {
        e = e || window.event;
        return e.target || e.srcElement;
    }

    onValueChange = (type, event) => {
        let target = this.getEventTarget(event);
        const value = target.textContent;
        this.updateFilterOptions(type, value);
    };

    /**
    *  Description The above code is defining a function called `onDataChange` that takes two parameters: `type`
    *  and `event`. Inside the function, it checks if the `type` parameter is either "startDate" or
    *  "endDate". If it is, it formats the `value` of the `event.target` using a utility function
    *  called `formatDateObject` from a module called `Utils`. Finally, it calls another function
    *  called `updateFilterOptions` with the `type` and `value` parameters.
    *  @param {string} type
    *  @param {html event} event
    */
    onDataChange = (type, event) => {
        let value = Utils.getValue(event);
        if (type === "startDate" || type === "endDate") {
            value = Utils.formatDateObject(value);
        }
        this.updateFilterOptions(type, value);
    }

    updateFilterOptions = (type, value) => {
        let filterOptions = { ...this.state.filterOptions };
        filterOptions[type] = value;
        this.setState({ filterOptions: filterOptions });
    }

    /**
    * Description The above code is defining an arrow function called `onClearfFilter` that takes an event object
    * as its parameter. Inside the function, it sets the `filterOptions` state of the component to its
    * default state, calls the `onApplyFilter` function with the default filter options as its
    *  argument, and then toggles the menu. This function is likely used to reset the filter options to
    *  their default values and apply the default filter to the data being displayed. 
    *  @param {html event} event
    */
    onClearfFilter = (event) => {
        this.setState({ filterOptions: this.defaultState.filterOptions });
        this.props.onApplyFilter(this.defaultState.filterOptions, true);
        this.toggleMenu(event);
    }

    /**
    * Description The above code is defining an arrow function called `applyFilter` that takes an event as an
    * argument. Within the function, it calls a function `onApplyFilter` that is passed as a prop to
    * the component, and passes in the current state of `filterOptions` as an argument. It then calls
    * another function `toggleMenu` and passes in the event as an argument. The purpose of this code
    * is to apply a filter based on the current state of `filterOptions` and then toggle a menu.
    * @param {html event} event
    */
    applyFilter = (event) => {
        this.props.onApplyFilter(this.state.filterOptions);
        this.toggleMenu(event);
    }


    // Method to find out passed item is null, mostly used as callback method in array methods
    isNull = (item) => !item

    render() {
        const {isMenuActive,filterOptions} = this.state;
        const disableApplyFilter=(Object.values(filterOptions).every(this.isNull));  // If every value is null, disable the apply button
       return (
            <>
                <div className={`menu-trigger ${isMenuActive ? "bg-blue" : ""}`} onClick={this.toggleMenu}>
                <OmniTooltipNextComponent> 
                    <button slot="invoker" aria-haspopup="true" className={`icon`}> 
                        <OmniIconComponent slot="end" className="menu-trigger is-size-2" icon-id="omni:interactive:filter"></OmniIconComponent> 
                    </button>
                    <div slot="content">Filters</div>
                </OmniTooltipNextComponent>
                </div>
                <Draggable nodeRef={this.nodeRef} axis="both" bounds='body' defaultPosition={{x: 54, y: 8}}>
                    <div ref={this.nodeRef}>
                        <div className="dropdown-menu-content v1-campaign-filter-container" id="dropdown-menu-content" role="menu">
                            <div>
                                <div className="media-flex media-justify-space-between filter-header">
                                    <span className='filter-title'>Filters</span>
                                    <OmniIconComponent onClick={this.toggleMenu} className="is-size-2 has-text-almost-black filter-close-icon"
                                        icon-id="omni:interactive:close"></OmniIconComponent>
                                </div>
                                <hr className='filter-header-bar'/>
                                <div className="filter-sections">
                                    <div className='filter-sections-list'>
                                        <section className="section-item media-direction-column">
                                            <div className="media-flex media-justify-space-between is-7 filter-label">
                                                <span className="filter-label-text">Campaign name</span>
                                                <a className="media-link" onClick={this.onClearfFilter}>Clear All</a>
                                            </div>
                                            <div className="full-width">
                                                <input type="text" placeholder="Campaign Name" value={this.state.filterOptions.campaignName}
                                                    onChange={this.onDataChange.bind(this, 'campaignName')} className="input text filter-field">
                                                </input>
                                            </div>
                                        </section>
                                        
                                        <section className="section-item media-direction-column">
                                            <div className="media-flex media-justify-space-between is-7 filter-label">
                                                <span className="filter-label-text">Export Status</span>
                                            </div>
                                            <div className="full-width">
                                            <OmniDropdownComponent
                                                typeahead
                                                searchindropdown
                                                options={this.state.exportStatusOptions}
                                                value={this.state.filterOptions.status? [this.state.filterOptions.status]:[]}
                                                onDropdownChange={(event) => this.onDataChange("status", event)}
                                                placeholder="Select Option"
                                                hidefooter={true}
                                                ></OmniDropdownComponent>
                                            </div>
                                        </section>

                                        <section className="section-item media-direction-column side-section">
                                            <label>
                                            <div className="media-flex media-justify-space-between is-7 filter-left-box filter-label">
                                                <span className="filter-label-text">Start date</span>
                                            </div>
                                            <div className="full-width">
                                                <input type="date" data-date={this.state.filterOptions.startDate !== "" ? this.state.filterOptions.startDate : "MM DD,YYYY" } value={this.state.filterOptions.startDate} 
                                                    onChange={this.onDataChange.bind(this, 'startDate')} className="input date is-large filter-field input-with-icon">
                                                </input>
                                            </div> 
                                            </label>
                                            <label>
                                            <div className="media-flex media-justify-space-between filter-right-box is-7 filter-label">
                                                <span className="filter-label-text">End date</span>
                                            </div>
                                            <div className="full-width">
                                                <input type="date" data-date={this.state.filterOptions.endDate !== "" ? this.state.filterOptions.endDate : "MM DD,YYYY" }onChange={this.onDataChange.bind(this, 'endDate')} value={this.state.filterOptions.endDate} className="input date is-large filter-field input-with-icon">
                                                </input>
                                            </div>
                                            </label>
                                        </section>

                                        <section className="section-item media-direction-column mt-4 side-section">
                                        <label>
                                            <div className="media-flex media-justify-space-between filter-left-box is-7 filter-label">
                                                <span className="filter-label-text">Net Media Min</span>
                                            </div>
                                            <div className="full-width">
                                            <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.budgetMin}
                                                onChange={this.onDataChange.bind(this, 'budgetMin')} className="input text filter-field">
                                            </input>
                                            </div>
                                            </label>
                                            <label>
                                            <div className="media-flex media-justify-space-between filter-right-box is-7 filter-label">
                                                <span className="filter-label-text">Net Media Max</span>
                                            </div>
                                            <div className="full-width">
                                            <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.budgetMax}
                                                onChange={this.onDataChange.bind(this, 'budgetMax')} className="input text filter-field">
                                            </input>
                                            </div>
                                            </label>
                                        </section>

                                        <section className="section-item media-direction-column">
                                            <div className="media-flex media-justify-space-between is-7 filter-label">
                                                <span className="filter-label-text">Client Code</span>
                                            </div>
                                            <div className="full-width">
                                                <input 
                                                    type="text" 
                                                    placeholder="Enter Client Code" 
                                                    value={filterOptions.clientCode}
                                                    onChange={this.onDataChange.bind(this, 'clientCode')} 
                                                    className="input text filter-field"
                                                />
                                            </div>
                                        </section>

                                        <section className="section-item media-direction-column">
                                            <div className="media-flex media-justify-space-between is-7 filter-label">
                                                <span className="filter-label-text">Product Code</span>
                                            </div>
                                            <div className="full-width">
                                                <input 
                                                    type="text" 
                                                    placeholder="Enter Product Code"
                                                    value={filterOptions.productCode}
                                                    onChange={this.onDataChange.bind(this, 'productCode')} 
                                                    className="input text filter-field"
                                                />
                                            </div>
                                        </section>

                                        <section className="section-item media-direction-column">
                                            <div className="media-flex media-justify-space-between is-7 filter-label">
                                                <span className="filter-label-text">Estimate Code</span>
                                            </div>
                                            <div className="full-width">
                                                <input 
                                                    type="text" 
                                                    placeholder="Enter Estimate Code"
                                                    value={filterOptions.estimateCode}
                                                    onChange={this.onDataChange.bind(this, 'estimateCode')} 
                                                    className="input text filter-field"
                                                />
                                            </div>
                                        </section>

                                        <section className="section-item media-direction-column">
                                            <div className="action-btns">
                                                <button className={`${disableApplyFilter ? 'secondary': ''}`} disabled={disableApplyFilter} onClick={this.applyFilter}>Apply filters</button>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </>
        )
    }

}